/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'hat': {
    width: 129,
    height: 82,
    viewBox: '0 0 129 82',
    data: `<desc>Created using Figma</desc><use xlink:href="#svgicon-hat-a"/><defs><path pid="0" id="svgicon-hat-a" fill-rule="evenodd" d="M51.943 10.292c-2.454 1.277-4.764 2.873-6.28 4.54L1.677 62.92c-3.03 3.334-1.84 5.568 2.67 5.036l35.039-4.255L49.092 82c-1.84-3.475 3.86-10 12.738-14.54 8.877-4.54 17.573-5.39 19.413-1.88-1.84-3.475 3.861-10 12.738-14.54 8.877-4.54 17.573-5.39 19.414-1.915l-9.707-18.264 23.636-25.747c3.031-3.333 1.84-5.568-2.671-5.036L72.294 6.355l12.377 23.407 7.398 6.277c.469.886-1.335 2.695-3.97 4.043-2.67 1.383-5.196 1.773-5.665.886l-.974-9.54L68.433 6.852l-9.13 1.1c-2.236.177-4.907 1.099-7.36 2.34z"/></defs>`
  }
})
